import React, { useState } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { InfoWindowView } from './infoWindowView';
import PropTypes from "prop-types";

const containerStyle = {
  width: '100%',
  height: '400px'
};

export function MapComponent(props) {
  const { address, center, icon, isMarkerShown, data } = props;
  const { latitude, longitude, lastPacketArriveAt } = data;

  const [isOpen, setIsOpen] = useState(true);

  // Explicit checks for valid lat/lng
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  const showMarker = isMarkerShown && !isNaN(lat) && !isNaN(lng);
  const markerLocation = { lat, lng };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
    >
      {showMarker && (
        <Marker
          position={markerLocation}
          onClick={() => setIsOpen(!isOpen)}
          icon={icon}
        >
          {isOpen && (
            <InfoWindow onCloseClick={() => setIsOpen(false)} position={markerLocation}>
              <InfoWindowView lastPacketArriveAt={lastPacketArriveAt} address={address} />
            </InfoWindow>
          )}
        </Marker>
      )}
    </GoogleMap>
  );
}
MapComponent.propTypes = {
  address: PropTypes.string,
  center: PropTypes.object,
  icon: PropTypes.any,
  isMarkerShown: PropTypes.bool,
  data: PropTypes.shape({
    latitude: PropTypes.any,
    longitude: PropTypes.any,
    lastPacketArriveAt: PropTypes.any,
  }),
};
